import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
// Note: StrictMode removed to prevent double-render issues with OAuth callback
// The session_id from Emergent auth is one-time use and double-render causes it to fail
root.render(<App />);
